export enum AuthorityCompanyAvailabilities {
  COMPANY_AVAILABILITY_VIEW = '1.1.9.1',
  COMPANY_AVAILABILITY_ADD = '1.1.9.2',
  COMPANY_AVAILABILITY_EDIT = '1.1.9.3',
  COMPANY_AVAILABILITY_DELETE = '1.1.9.4',
}
